import { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import axios from "axios";
import getAPI from "../../service/getAPI";

const ExcelTable = ({ userData }) => {
  const { master } = getAPI();
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // Change as needed

  // Fetch uploaded data from the API after file upload
  const fetchUploadedData = async () => {
    try {
      const response = await axios.post(master.get_uploaded_data); // API to fetch uploaded records
      setFilteredData(response.data.data);
    } catch (error) {
      console.error("Error fetching table data", error);
    }
  };

  // Update table when userData changes
  useEffect(() => {
    if (userData?.data) {
      setFilteredData(userData.data);
    } else {
      fetchUploadedData(); // Fetch data if userData is not available
    }
  }, [userData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    if (!isNaN(dateString) && dateString > 40000) {
      const excelDate = new Date((dateString - 25569) * 86400000);
      return excelDate.toLocaleDateString("en-GB");
    }
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? dateString : date.toLocaleDateString("en-GB");
  };

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <div className="row mt-3">
      <div className="col-md-12">
        <div className="table-responsive">
          <Table striped bordered hover responsive>
            <thead>
              <tr className="table-secondary">
                <th>No.</th>
                <th>Order Date</th>
                <th>Name</th>
                <th>Phone No</th>
                <th>Product</th>
                <th>Address</th>
                <th>State</th>
                <th>Pincode</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.length > 0 ? (
                currentRecords.map((order, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstRecord + index + 1}</td>
                    <td>{formatDate(order.order_date)}</td>
                    <td>{order.name}</td>
                    <td>{order.phone_number}</td>
                    <td>{order.product}</td>
                    <td>{order.address}</td>
                    <td>{order.state}</td>
                    <td>{order.pincode}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination UI */}
        {totalPages > 1 && (
          <div className="card-footer">
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-end">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo; Prev
                  </button>
                </li>
                <li className="page-item">
                  <span className="page-link">
                    Page {currentPage} of {totalPages}
                  </span>
                </li>
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExcelTable;
